function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7489 7.74827L8.74889 10.7483M18.0369 0.779266C18.1318 0.746521 18.234 0.741132 18.3318 0.763715C18.4296 0.786299 18.5191 0.835944 18.59 0.906976C18.6609 0.978008 18.7104 1.06756 18.7329 1.1654C18.7553 1.26324 18.7498 1.36542 18.7169 1.46027L12.7929 18.3903C12.7574 18.4915 12.6924 18.5797 12.6062 18.6435C12.52 18.7073 12.4166 18.7437 12.3095 18.748C12.2023 18.7523 12.0964 18.7243 12.0053 18.6677C11.9143 18.611 11.8424 18.5283 11.7989 18.4303L8.57989 11.1883C8.52573 11.0678 8.42932 10.9714 8.30889 10.9173L1.06689 7.69727C0.969181 7.65364 0.886802 7.58172 0.83039 7.4908C0.773978 7.39988 0.746127 7.29413 0.750434 7.18721C0.75474 7.0803 0.791007 6.97713 0.854549 6.89104C0.918091 6.80495 1.00599 6.73989 1.10689 6.70427L18.0369 0.779266Z",
  stroke: "#247079",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPlaneEmpty = function SvgPlaneEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaneEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane_empty.7123e563.svg";
export { ForwardRef as ReactComponent };